/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, InputGroup, Row, } from 'react-bootstrap';
import { FaCheck, FaCircleInfo, FaTriangleExclamation, FaFileContract, FaCreditCard } from 'react-icons/fa6';
import { InputMask } from 'primereact/inputmask';
import { messages, format, layout, http, validate, ref, triggerConfetti, } from '@/helpers/index';
import { auth } from '@/services/auth';
import Pix from '../pix';

export default function SalesCommunication({ options, }) {
  const { product, } = options;
  const user = auth.store.logged.get();
  const [addCoupon, setAddCoupon] = useState(false);
  const [order, setOrder] = useState();
  const [communication, setCommunication] = useState();
  const [billing, setBilling] = useState();
  const [coupon, setCoupon] = useState();
  const couponRef = useRef();
  const documentFrontRef = useRef();
  const documentRearRef = useRef();
  const [state, setState] = useState({
    items: [{ quantity: 1, value: product?.value || 69, name: product?.name || 'Comunicação Venda' }],
    coupon: {},
    total: product?.value || 69,
    balance: product?.value || 69,
  });
  const [body, setBody] = useState({
    name: '',
    document: '',
    mobile: '',
    email: '',
    documentType: 'ATPV',
    plate: '',
  });

  const init = () => {
    layout.focus('inquiryPlate');
    if (user) {
      setBody({
        ...body,
        name: user.name,
        document: user.document,
        email: user.email,
        mobile: user.mobile,
      });
    }
  };

  useEffect(() => {
    init();
    const inquiryPlate = layout.inquiry.get();
    if (inquiryPlate) {
      setBody({ ...body, plate: inquiryPlate.replaceAll(/[_-]/g, '').toUpperCase() });
    }
  }, []);

  const handleCoupon = () => {
    const reset = () => {
      const value = state;
      value.coupon = {};
      value.balance = value.total;
      delete value.items[0].discount;
      setState(value);
      setCoupon();
      messages.clear();
    };
    if (!couponRef.current.value) {
      layout.focus('coupon');
      reset();
      return;
    }
    layout.loading(true);
    const code = couponRef.current.value;
    http.get(`/coupons/${code.toUpperCase()}`, (result) => {
      layout.loading(false);
      if (!result) {
        reset();
        messages.alert('Por favor, informe um cupom válido.', false, true);
        return;
      }
      const data = { ...state };
      data.coupon = result;
      data.balance = data.total - (data.total * result.discount);
      data.items[0].discount = result.discount;
      setState(data);
      setCoupon(result);
      messages.clear();
      couponRef.current.value = '';
    });
  };

  const handleOnChangeSwitch = ({ target }) => {
    setAddCoupon(target.checked);
    if (!target.checked) {
      handleCoupon();
    }
  };

  const handleInputChange = ({ target }) => {
    setBody({ ...body, [target.name]: target.value });
  };

  const handleInputFocus = ({ target }) => {
    target.select();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (body.plate.length < 7) {
      layout.focus('inquiryPlate');
      return;
    }
    if (!validate.plate(body.plate)) {
      layout.focus('inquiryPlate');
      return;
    }
    if (!ref.files.check(documentFrontRef)) {
      messages.alert(`Por favor, informe a imagem referente ao documento: ${body.documentType}.`, false, true);
      return;
    }
    if (body.documentType === 'DUT' && !ref.files.check(documentRearRef)) {
      messages.alert('Por favor, informe a imagem referente ao documento DUT - Verso.', false, true);
      return;
    }

    setBilling(true);
    layout.loading(true);
    const formData = new FormData();
    if (ref.files.check(documentFrontRef)) {
      formData.append('document', documentFrontRef.current.files[0]);
    }
    if (body.documentType === 'DUT' && ref.files.check(documentRearRef)) {
      formData.append('document', documentRearRef.current.files[0]);
    }
    formData.append('plate', body.plate.replaceAll(/[_-]/g, '').toUpperCase());
    formData.append('type', body.documentType);
    formData.append('productId', product._id);
    formData.append('userName', format.capitalize(body.name));
    formData.append('userDocument', body.document);
    formData.append('userEmail', body.email);
    formData.append('userMobile', body.mobile);
    formData.append('total', state.total);
    formData.append('value', state.balance);
    formData.append('description', `Comunicação de Venda - ${body.name} - ${body.plate}`);
    formData.append('couponCode', state.coupon ? state.coupon.code || '' : '');
    formData.append('couponDiscount', state.coupon ? state.coupon.discount || 0 : 0);
    http.post('/quick/communicate', formData, (result, resultError) => {
      setBilling(false);
      layout.loading(false);
      if (result) {
        triggerConfetti();
        if (order) {
          setCommunication(result.communication);
        }
        setOrder(result.order);
        return;
      }
      setOrder();
      setCommunication();
      if (resultError.message) {
        messages.error(resultError.message, false, true);
        return;
      }
      messages.error('Ocorreu um erro ao tentar enviar sua solicitação de comunicação de venda. Por favor, tente novamente.', false, true);
    }, true);
  };

  const handleNew = () => {
    setCommunication();
    setOrder();
    init();
  };

  return (
    <Container className="py-3">
      <div className="text-center mb-4">
        <span className="about-home mb-2">Serviço Oficial</span>
        <h1 className="display-5 fw-extrabold text-dark mt-2 mb-1">{product?.name || 'Comunicação Venda'}</h1>
        <p className="lead text-secondary small">Preencha os dados abaixo para realizar a comunicação de venda do seu veículo de forma rápida e segura.</p>
      </div>

      {!communication && state.items.length > 0 && (
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <Form onSubmit={handleSubmit}>

              <Card className="border-0 shadow-sm rounded-4 mb-4">
                <Card.Header className="bg-transparent border-0 pt-4 px-4 pb-0 d-flex align-items-center">
                  <FaFileContract className="text-primary fs-4 me-2" />
                  <h4 className="fw-bold text-dark mb-0 fs-5">Dados da Solicitação</h4>
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="g-3">
                    <Col xs={12} sm={6} md={3}>
                      <Form.Group>
                        <Form.Label htmlFor="inquiryPlate" className="fw-semibold text-secondary small mb-1">Placa do Veículo</Form.Label>
                        <InputMask
                          id="inquiryPlate"
                          name="plate"
                          className="form-control form-control-lg rounded-3 py-2 px-3 fw-bold input-uppercase shadow-sm border-light-subtle"
                          mask="aaa9*99"
                          slotChar=""
                          required
                          value={body.plate}
                          onChange={handleInputChange}
                          placeholder="ABC1D23"
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <Form.Group>
                        <Form.Label htmlFor="documentType" className="fw-semibold text-secondary small mb-1">Tipo do Documento</Form.Label>
                        <Form.Select
                          name="documentType"
                          id="documentType"
                          className="form-select form-select-lg rounded-3 py-2 px-3 shadow-sm border-light-subtle"
                          value={body.documentType}
                          onChange={handleInputChange}
                        >
                          <option value="ATPV">ATPV (Digital)</option>
                          <option value="DUT">DUT (Papel)</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {body.documentType === 'ATPV' && (
                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label htmlFor="atpv" className="fw-semibold text-secondary small mb-1">Anexar ATPV</Form.Label>
                          <Form.Control
                            id="atpv"
                            name="atpv"
                            type="file"
                            className="rounded-3 shadow-sm py-2 px-3 border-light-subtle"
                            required
                            onChange={handleInputChange}
                            accept="image/png, image/jpeg, application/pdf"
                            ref={documentFrontRef}
                          />
                        </Form.Group>
                      </Col>
                    )}
                    {body.documentType === 'DUT' && (
                      <>
                        <Col xs={12} md={3}>
                          <Form.Group>
                            <Form.Label htmlFor="dutFront" className="fw-semibold text-secondary small mb-1">DUT - Frente</Form.Label>
                            <Form.Control
                              id="dutFront"
                              name="dutFront"
                              type="file"
                              className="rounded-3 shadow-sm py-2 px-3 border-light-subtle"
                              required
                              onChange={handleInputChange}
                              accept="image/png, image/jpeg, application/pdf"
                              ref={documentFrontRef}
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={3}>
                          <Form.Group>
                            <Form.Label htmlFor="dutRear" className="fw-semibold text-secondary small mb-1">DUT - Verso</Form.Label>
                            <Form.Control
                              id="dutRear"
                              name="dutRear"
                              type="file"
                              className="rounded-3 shadow-sm py-2 px-3 border-light-subtle"
                              required
                              onChange={handleInputChange}
                              accept="image/png, image/jpeg, application/pdf"
                              ref={documentRearRef}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}

                    <Col xs={12} md={8}>
                      <Form.Group>
                        <Form.Label htmlFor="name" className="fw-semibold text-secondary small mb-1">Nome Completo do Vendedor</Form.Label>
                        <Form.Control
                          type="text"
                          id="name"
                          name="name"
                          className="rounded-3 py-2 px-3 shadow-sm border-light-subtle"
                          placeholder="Digite o nome completo do vendedor"
                          required
                          value={body.name}
                          onChange={handleInputChange}
                          onFocus={handleInputFocus}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label htmlFor="document" className="fw-semibold text-secondary small mb-1">CPF do Vendedor</Form.Label>
                        <InputMask
                          name="document"
                          id="document"
                          value={body.document}
                          className="form-control rounded-3 py-2 px-3 shadow-sm border-light-subtle"
                          mask="999.999.999-99"
                          slotChar=""
                          onChange={(event) => {
                            setBody({ ...body, document: event.target.value });
                          }}
                          placeholder="000.000.000-00"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={8}>
                      <Form.Group>
                        <Form.Label htmlFor="email" className="fw-semibold text-secondary small mb-1">E-mail para Recebimento</Form.Label>
                        <Form.Control
                          type="email"
                          id="email"
                          name="email"
                          className="rounded-3 py-2 px-3 shadow-sm border-light-subtle"
                          placeholder="seuemail@exemplo.com.br"
                          required
                          value={body.email}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label htmlFor="mobile" className="fw-semibold text-secondary small mb-1">Telefone WhatsApp</Form.Label>
                        <InputMask
                          name="mobile"
                          id="mobile"
                          className="form-control rounded-3 py-2 px-3 shadow-sm border-light-subtle"
                          mask="(99) 99999-9999"
                          slotChar=""
                          placeholder="(00) 00000-0000"
                          value={body.mobile}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <div className="alert alert-primary border-0 shadow-sm rounded-4 p-4 mb-4 d-flex align-items-start gap-3">
                <FaCircleInfo className="text-primary fs-3 flex-shrink-0 mt-1" />
                <div className="small text-secondary leading-normal">
                  <span className="fw-bold text-primary d-block fs-6 mb-1">Instruções Importantes para Envio</span>
                  {body.documentType === 'ATPV' && (
                    <span>
                      Certifique-se de enviar a <strong>Autorização para Transferência de Propriedade do Veículo (ATPV)</strong> preenchida com as informações do <strong>Local da Venda</strong>, <strong>Data da Venda</strong> e <strong>Assinatura do Vendedor</strong>.
                    </span>
                  )}
                  {body.documentType === 'DUT' && (
                    <span>
                      Certifique-se de enviar a frente e o verso do <strong>Documento Único de Transferência (DUT)</strong> preenchido com o <strong>Endereço, Nome e CPF do Comprador</strong>, além do <strong>Local e Data da Venda</strong> com <strong>Assinatura do Vendedor</strong>.
                    </span>
                  )}
                </div>
              </div>

              <Card className="border-0 shadow-sm rounded-4 position-relative mb-4 overflow-hidden">
                <div className="ribbon ribbon-top-right"><span>Promoção</span></div>
                <Card.Header className="bg-transparent border-0 pt-4 px-4 pb-0 d-flex align-items-center">
                  <FaCreditCard className="text-primary fs-4 me-2" />
                  <h4 className="fw-bold text-dark mb-0 fs-5">Pagamento</h4>
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="g-4 align-items-center">
                    <Col xs={12} md={5}>
                      <div className="bg-light p-3 rounded-4 border border-light-subtle">
                        <span className="badge bg-primary text-white rounded-pill px-3 py-1 mb-2 small fw-bold">RESUMO</span>
                        <div className="h5 fw-bold text-dark mb-1">{product?.name || 'Comunicação Venda'}</div>
                        <div className="my-2">
                          {product?.value === state.balance ? (
                            <span className="h2 fw-extrabold text-primary mb-0">{format.currency(state.balance)}</span>
                          ) : (
                            <div className="d-flex align-items-baseline gap-2">
                              <span className="text-muted text-decoration-line-through fs-6">{format.currency(product?.value || 79)}</span>
                              <span className="h2 fw-extrabold text-primary mb-0">{format.currency(state.balance)}</span>
                            </div>
                          )}
                        </div>
                        <p className="small text-secondary mb-0">{product?.description || 'Vendeu seu veículo? Faça a Comunicação de Venda agora mesmo.'}</p>
                      </div>
                    </Col>

                    <Col xs={12} md={7}>
                      {!order?.payment && (
                        <>
                          <div className="mb-3">
                            <Form.Check
                              type="switch"
                              id="hasCoupon"
                              name="hasCoupon"
                              label="Possuo um cupom de desconto"
                              className="fw-semibold text-secondary"
                              onChange={handleOnChangeSwitch}
                            />
                          </div>
                          {addCoupon && (
                            <Form.Group className="mb-3">
                              <InputGroup className="shadow-sm rounded-pill overflow-hidden border">
                                <Form.Control
                                  type="text"
                                  id="coupon"
                                  name="coupon"
                                  ref={couponRef}
                                  className="border-0 px-3 py-2"
                                  placeholder={coupon ? `${coupon.code} = ${coupon.discount * 100}%` : 'Digite seu cupom'}
                                />
                                <Button type="button" className="btn-gradient-primary border-0 px-4 fw-bold" onClick={handleCoupon}>
                                  <FaCheck className="me-1" /> Aplicar
                                </Button>
                              </InputGroup>
                            </Form.Group>
                          )}
                        </>
                      )}
                      {order?.payment && (
                        <div className="my-3">
                          <Pix order={order} showCountdown />
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card.Body>

                <Card.Footer className="bg-transparent border-top-0 p-4 pt-0 text-center">
                  {!order && (
                    <Button type="submit" size="lg" className="btn-gradient-success rounded-pill px-5 py-3 fw-bold border-0 fs-5 w-100 w-md-auto">
                      Efetuar Pagamento
                    </Button>
                  )}
                </Card.Footer>
              </Card>

              <div className="alert alert-warning border-0 shadow-sm rounded-4 p-4 text-center mb-4">
                <FaTriangleExclamation className="text-warning fs-3 mb-2" />
                <h5 className="fw-bold text-dark mb-1">Processamento em Fila Segura</h5>
                <p className="small text-secondary mb-1">
                  Assim que enviar sua solicitação, ela entrará em nossa fila de processamento e será executada nas próximas <strong>24 horas</strong>.
                </p>
                <div className="fw-bold text-dark small">O recibo da comunicação será enviado para o e-mail informado acima.</div>
              </div>

            </Form>
          </Col>
        </Row>
      )}

      {communication && (
        <Row className="justify-content-center">
          <Col lg={8}>
            <Alert variant="success" className="border-0 shadow-sm rounded-4 p-4 text-center">
              <div className="h4 fw-bold text-success mb-2">Parabéns! Solicitação Enviada</div>
              <p className="text-secondary mb-2">Sua solicitação de comunicação de venda foi enviada com sucesso! Após confirmação de pagamento, será executada nas próximas 24 horas.</p>
              <div className="fw-bold text-dark small mb-4">O recibo oficial será enviado para o e-mail cadastrado na solicitação.</div>
              <Button type="button" className="btn-gradient-primary rounded-pill px-4 py-2 fw-bold border-0 shadow-sm" onClick={handleNew}>
                <FaCheck className="me-2" />
                Solicitar nova comunicação
              </Button>
            </Alert>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export async function getServerSideProps(context) {
  const res = await http.baseAsync('GET', '/configurations');
  let warning = '';
  if (res.ok) {
    const item = await res.json();
    if (item && !item.vendors.checktudo.online) {
      warning = item.vendors.message;
    }
  }

  const resProduct = await http.baseAsync('GET', '/products/comunicacao-venda', null, false, auth.headers());
  const product = await resProduct.json();

  return {
    props: {
      warning,
      product,
    },
  };
}
